import { getCrmCountryList } from '@api/AddressCountries'
import { mapDataToSelectData } from '@api/Helpers'

import type { CrmCountry } from '@api/AddressCountries'

/* Usage

    <select
      data-crm-countries <!-- pass optional string to sort on load: 'uk first' | 'name asc' | 'name desc' -->
    ></select>

*/

function initialiseCrmCountrySelects(mode: 'all' | string) {
    // mode should be string 'all' for each [data-crm-countries], or you can supply an HTML class or ID as the target

    // #region <Vars>
    const selector = (mode === 'all' ? '[data-crm-countries]' : mode)
    const crmCountrySelects = document.querySelectorAll(selector)
    // #endregion

    // #region <initialise all country select tags>
    crmCountrySelects.forEach((crmCountrySelect) => {
        const optionalSort = crmCountrySelect.getAttribute('data-crm-countries') as 'uk first' | 'name asc' | 'name desc' | undefined
        const optionalDefault = crmCountrySelect.getAttribute('data-default-value') as string | undefined

        const countryList = getCrmCountryList(optionalSort) as CrmCountry[]

        const data = mapDataToSelectData(countryList, 'CountryId', 'DisplayName')

        const fragment = document.createDocumentFragment()

        data.forEach((opt: any) => {
            const option = document.createElement('option')
            option.value = opt.value
            option.textContent = opt.label

            if (optionalDefault && optionalDefault === opt.value)
                option.selected = true

            fragment.appendChild(option)
        })

        crmCountrySelect.appendChild(fragment)
    })
    // #endregion
}

(window as any).initialiseCrmCountrySelects = initialiseCrmCountrySelects

document.addEventListener('DOMContentLoaded', () => {
    initialiseCrmCountrySelects('all')
})
